VjsAdmin.MyPassword = (function () {
    function validatePasswordLength() {
        const password = $('#reset_password').val();
        if (password.length >= 8 && password.length <= 100) {
            $('#reset_password').removeClass('is-invalid');
            enableSubmit();
            return true;
        }
        $('#reset_password').addClass('is-invalid');
        disableSubmit();
        return false;
    }

    function validatePasswordMatch() {
        const password = $('#reset_password').val();
        const passwordConfirm = $('#reset_password_confirm').val();
        if (password === passwordConfirm) {
            $('#reset_password_confirm').removeClass('is-invalid');
            validatePasswordLength();
            return true;
        }
        $('#reset_password_confirm').addClass('is-invalid');
        disableSubmit();
        return false;
    }

    function disableSubmit() {
        $('input[type=submit]').prop('disabled', true).attr('title', 'Please fill out all required fields.');
    }

    function enableSubmit() {
        $('input[type=submit]').prop('disabled', false).attr('title', '');
    }

    const init = function () {
        $('#generate-password').on('click', (e) => {
            e.preventDefault();
            let newPassword = $.passGen({ length: 10 });
            newPassword = newPassword.replace(/l/g, 'L');
            newPassword = newPassword.replace(/1/g, 'X');
            newPassword = newPassword.replace(/0/g, 'Z');
            newPassword = newPassword.replace(/O/g, 'Z');
            newPassword = newPassword.replace(/o/g, 'z');
            $('#reset_password,#reset_password_confirm').val(newPassword).attr('type', 'text').trigger('input');
        });

        $('#reset_password, #reset_password_confirm').on('input', () => {
            validatePasswordLength();
            validatePasswordMatch();
        });
    };

    return {
        init,
    };
}());
